import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class PartnerMaintenanceService {
  constructor(private http: HttpClient) {}

  loadPartnerList(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;

    // Build params with proper fallbacks
    const requestParams = _.merge({}, globalService || {}, params);

    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  savePartnerSetup(
    baseUrl: string,
    settings: any,
    data: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=hweg49`;

    const jsonObj = JSON.stringify(data);
    const jsonSettings = JSON.stringify(settings);

    // 🚀 CRITICAL: Merge globalParams first (contains checkLockedbj, scenarioCode, is_issue_key_enabled)
    // Note: Component passes globalService which is already header.globalParams
    let params = _.merge({}, globalService || {}, filterParams);

    // Essential parameters with fallbacks
    params.clob_data = jsonObj;
    params.clob_settings = jsonSettings;
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || globalService?.jcd_key || 250;
    params.process_name = "Partner Management";
    params.sso_id = settings.sso_id;

    // 🚀 CRITICAL: Ensure critical parameters are included with fallbacks
    params.scenarioCode = filterParams.scenarioCode || params.scenarioCode || filterParams.scenario || params.scenario || globalService?.scenarioCode || 'RAF';
    params.is_issue_key_enabled = filterParams.is_issue_key_enabled || params.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    
    // 🚀 CRITICAL: Build checkLockedbj if not present in globalParams
    // Pattern matches json-object-factory.service.ts and other components
    if (!params.checkLockedbj) {
      const checkLockedbj = [{
        leid: rowData.LEID || rowData.SOURCE_LEID || '',
        me_code: rowData.ME_CODE || rowData.ME || rowData.SOURCE_ME_CODE || '',
        cdr_number: rowData.CDR_NO || rowData.TAX_CODE || rowData.SOURCE_CDR_NO || rowData.LEID || '',
        consol_group_key: rowData.CONSOL_GROUP_KEY || rowData.FILING_GROUP || '',
        reporting_period: rowData.REPORTING_PERIOD || rowData.SOURCE_REPORTING_PERIOD || rowData.RP || 1,
        combination_key: rowData.COMBINATION_KEY || rowData.COMPL_COMBINATION_KEY || rowData.HO_COMBINATION_KEY || 0,
        scenario_key: rowData.SCENARIO_KEY || filterParams.scenario || params.scenario || 74
      }];
      params.checkLockedbj = JSON.stringify(checkLockedbj);
    }

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

